module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "calibre11",
    attrs: {
      "id": "pgepubid00004"
    }
  }, [_vm._v("LIST OF CHAPTERS")]), _vm._v(" "), _c('table', {
    staticClass: "calibre19",
    attrs: {
      "cellpadding": "2",
      "cellspacing": "0",
      "summary": "toc"
    }
  }, [_c('tbody', {
    staticClass: "calibre20"
  }, [_c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0005"
    }
  }, [_vm._v("1.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("The Way to Butterfield")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0006"
    }
  }, [_vm._v("2.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("Dorothy Meets Button-bright")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0007"
    }
  }, [_vm._v("3.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("A Queer Village")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("King Dox")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("The Rainbow's Daughter")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("The City of Beasts")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("The Shaggy Man's Transformation")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("The Musicker")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("Facing the Scoodlers")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("Escaping the Soup-kettle")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("Johnny Dooit Does It")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("The Deadly Desert Crossed")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("The Truth Pond")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("Tik-Tok and Billina")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("The Emperor's Tin Castle")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("Visiting the Pumpkin-Field")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("The Royal Chariot Arrives")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("The Emerald City")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("The Shaggy Man's Welcome")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("Princess Ozma of Oz")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("Dorothy Receives the Guests")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("Important Arrivals")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("The Grand Banquet")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre21"
  }, [_c('td', {
    staticClass: "calibre22"
  }, [_c('span', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "href": "#/Text/Section0028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24.")])]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("The Birthday Celebration")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "calibre13",
    attrs: {
      "alt": "image not available",
      "id": "id-759205376910295977",
      "src": "Images/img0007.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre16"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1 pcalibre2 calibre1",
    attrs: {
      "id": "CHAP_1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0